module.exports = __webpack_public_path__ + "app/principal/principal-info-167M0OnV.html";